import { useEffect, useState } from "react";

const useWebView = () => {
    const [isWebView, setIsWebView] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("inAppWebView")) {
            const consentBanner = document.querySelector(".consent_banner");
            if (consentBanner) {
                (consentBanner as HTMLElement).style.display = "none";
            }
            setIsWebView(true);
        }
    }, []);

    return isWebView;
};

export default useWebView;
